var _ellipse, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoyalties(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23C15.5 22.7239 15.7239 22.5 16 22.5H33C33.2761 22.5 33.5 22.7239 33.5 23V24C33.5 24.8284 32.8284 25.5 32 25.5H17C16.1716 25.5 15.5 24.8284 15.5 24V23Z",
    fill: "white",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.367 2.96461C10.2321 2.4922 10.7881 2.12881 11.1666 2.44205L14.7659 5.42077C15.6276 6.13395 16.8583 6.18788 17.7791 5.55281L22.6484 2.19469C23.1611 1.84111 23.8389 1.84111 24.3516 2.19469L29.2209 5.55281C30.1417 6.18788 31.3724 6.13395 32.2341 5.42077L36.1792 2.15587C36.5402 1.85715 37.0768 2.17438 36.9892 2.63462L33.6637 20.0936C33.6187 20.3294 33.4126 20.5 33.1725 20.5H15.7543C15.5311 20.5 15.3349 20.352 15.2735 20.1374L10.367 2.96461Z",
    fill: "white",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24121 20.5H8.84473V10.7969H5.24121V20.5ZM7.04297 10.2607C8.0625 10.2607 8.83594 9.52246 8.83594 8.55566C8.83594 7.58887 8.0625 6.85059 7.04297 6.85059C6.02344 6.85059 5.25 7.58887 5.25 8.55566C5.25 9.52246 6.02344 10.2607 7.04297 10.2607ZM10.1982 20.5H13.8018V10.7969H10.1982V20.5ZM12 10.2607C13.0195 10.2607 13.793 9.52246 13.793 8.55566C13.793 7.58887 13.0195 6.85059 12 6.85059C10.9805 6.85059 10.207 7.58887 10.207 8.55566C10.207 9.52246 10.9805 10.2607 12 10.2607ZM15.1553 20.5H18.7588V10.7969H15.1553V20.5ZM16.957 10.2607C17.9766 10.2607 18.75 9.52246 18.75 8.55566C18.75 7.58887 17.9766 6.85059 16.957 6.85059C15.9375 6.85059 15.1641 7.58887 15.1641 8.55566C15.1641 9.52246 15.9375 10.2607 16.957 10.2607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyalties);
export default __webpack_public_path__ + "static/media/Royalties.c215785f729cb7a2493c938725ee6e84.svg";
export { ForwardRef as ReactComponent };